import React, { useState } from 'react';
import { Search, Shield, ChevronDown, ChevronRight } from 'lucide-react';
import { SECTIONS } from '../../data/apiDocsData';

const METHOD_COLORS = {
  GET:    'bg-sky-100 text-sky-700',
  POST:   'bg-emerald-100 text-emerald-700',
  PUT:    'bg-amber-100 text-amber-700',
  DELETE: 'bg-red-100 text-red-700',
};

export function Sidebar({ activeId, onSelect }) {
  const [search, setSearch] = useState('');
  const [collapsed, setCollapsed] = useState({});

  const q = search.toLowerCase();
  const filtered = SECTIONS.map(sec => ({
    ...sec,
    endpoints: sec.endpoints.filter(ep =>
      !q || ep.label.toLowerCase().includes(q) || sec.label.toLowerCase().includes(q)
    ),
  })).filter(sec => sec.endpoints.length > 0);

  const toggle = id => setCollapsed(c => ({ ...c, [id]: !c[id] }));

  return (
    <aside className="flex flex-col h-full bg-slate-50 border-r border-slate-200 overflow-hidden">
      {/* Search */}
      <div className="p-3 border-b border-slate-200 flex-shrink-0">
        <div className="relative">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400" />
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search APIs..."
            className="w-full pl-8 pr-3 py-2 text-xs bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-slate-400"
          />
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-2">
        {filtered.map(section => {
          const isOpen = !collapsed[section.id];
          return (
            <div key={section.id} className="mb-1">
              {/* Section header */}
              <button
                onClick={() => toggle(section.id)}
                className="w-full flex items-center justify-between px-4 py-2 text-xs font-bold uppercase tracking-widest text-slate-500 hover:text-slate-700 transition-colors"
              >
                <span className="flex items-center gap-1.5">
                  {section.label}
                  {section.badge && (
                    <span className="px-1.5 py-0.5 text-[10px] font-bold bg-blue-100 text-blue-600 rounded-full">
                      {section.badge}
                    </span>
                  )}
                </span>
                {isOpen
                  ? <ChevronDown className="w-3 h-3" />
                  : <ChevronRight className="w-3 h-3" />}
              </button>

              {/* Endpoints */}
              {isOpen && (
                <ul>
                  {section.endpoints.map(ep => {
                    const isActive = activeId === ep.id;
                    return (
                      <li key={ep.id}>
                        <button
                          onClick={() => onSelect(ep.id)}
                          className={`w-full flex items-center gap-2.5 px-4 py-2 text-sm text-left transition-colors
                            ${isActive
                              ? 'border-l-2 border-blue-600 bg-blue-50 text-blue-700 font-medium pl-[14px]'
                              : 'border-l-2 border-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-800 pl-[14px]'
                            }`}
                        >
                          {ep.method && (
                            <span className={`flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold rounded ${METHOD_COLORS[ep.method] || 'bg-slate-100 text-slate-600'}`}>
                              {ep.method}
                            </span>
                          )}
                          <span className="truncate text-xs">{ep.label}</span>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
